import { Component, EventEmitter, Output } from '@angular/core';
import { Store } from '@ngrx/store';

import { RootStoreState } from 'src/app/store';

@Component({
  selector: 'app-document-acknowledgement-alert',
  templateUrl: './document-acknowledgement-alert.component.html',
  styleUrls: ['./document-acknowledgement-alert.component.scss'],
  standalone: false,
})
export class DocumentAcknowledgementAlertComponent {
  @Output() acknowledge = new EventEmitter<void>();

  constructor(private readonly store: Store<RootStoreState.State>) {}

  acknowledgeClick() {
    this.acknowledge.emit();
  }
}
